
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[creatorSlug]/[productSlug]/purchase",
      function () {
        return require("private-next-pages/[creatorSlug]/[productSlug]/purchase.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[creatorSlug]/[productSlug]/purchase"])
      });
    }
  